<template>
  <div>
    <vue-html2pdf :show-layout="false" :float-layout="true" :enable-download="false" :preview-modal="true"
      :paginate-elements-by-height="1400" filename="" :pdf-quality="0.5" :manual-pagination="false" pdf-format="a3"
      pdf-orientation="landscape" pdf-content-width="100%" @progress="onProgress($event)"
      @beforeDownload="beforeDownload($event)" ref="html2Pdf">
      <section slot="pdf-content">
        <!-- PDF Content Here -->
        <pdf-conten-click v-if="!individuOrB2b" :dataDetail="dataForExport"></pdf-conten-click>
        <pdf-conten-click-b2b v-if="individuOrB2b" :dataDetail="dataForExport"></pdf-conten-click-b2b>
      </section>
    </vue-html2pdf>

    <v-btn depressed :disabled="isGenerating" color="red darken-1" @click="downloadPdf" class="white--text">
      {{ isGenerating ? "Loading..." : "Export PDF" }}
      <v-icon dark> mdi-file-download </v-icon>
    </v-btn>
  </div>
</template>

<script>
import PdfContenClick from "./PdfContentClick.vue";
import PdfContenClickB2b from "./PdfContentClickB2b.vue";
import VueHtml2pdf from "vue-html2pdf";

export default {
  name: "ExportPdfClick",

  props: ["dataForExport", "individuOrB2b"],

  data() {
    return {
      contentRendered: false,
      progress: 0,
      generatingPdf: false,
      pdfDownloaded: false,
    };
  },

  computed: {
    isGenerating() {
      return this.progress !== 0 && this.progress !== 100;
    },

    beforeDownload(isDownload) {
      return {
        ...isDownload,
        options: { ...isDownload.options, filename: "TESTWAHYU.pdf" },
      };
    },

    // htmlToPdfOptions() {
    //   return {
    //     margin: 0,

    //     filename: "test.pdf",

    //     image: {
    //       type: "jpeg",
    //       quality: 0.98,
    //     },

    //     enableLinks: true,

    //     html2canvas: {
    //       scale: 1,
    //       useCORS: true
    //     },

    //     jsPDF: {
    //       unit: 'in',
    //       format: 'a3',
    //       orientation: 'landscape'
    //     }
    //   };
    // },
  },

  methods: {
    async downloadPdf() {
      await this.$refs.html2Pdf.generatePdf();
    },

    onProgress(progress) {
      this.progress = progress;
      // console.log(`PDF generation progress: ${progress}%`)
    },
  },

  components: {
    VueHtml2pdf,
    PdfContenClick,
    PdfContenClickB2b,
  },
};
</script>

<style>
iframe {
  height: 100% !important;
}
</style>